import { render, staticRenderFns } from "./MaterialsDemo.vue?vue&type=template&id=c0352924&scoped=true"
import script from "./MaterialsDemo.vue?vue&type=script&lang=js"
export * from "./MaterialsDemo.vue?vue&type=script&lang=js"
import style0 from "./MaterialsDemo.vue?vue&type=style&index=0&id=c0352924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0352924",
  null
  
)

export default component.exports